import { observer } from "mobx-react";

import "./RadioSelector.scss";

const RadioSelector = observer(({ store }) => {

  return (
    <div className="radio-selector">
      <legend className="radio-selector__title">Как распределить переходы?</legend>
      <div className="radio-selector__container">
        <div className="radio-selector__input">
          <input
            type="radio"
            id="evenly"
            name="distribution"
            value="evenly"
            checked={!store.simulateFreqs}
            onChange={() => store.setSimulateFreqs(false)}
          />
          <label className="radio-selector__input-label" htmlFor="evenly">Равномерно</label>
        </div>

        <div className="radio-selector__input">
          <input
            type="radio"
            id="unevenly"
            name="distribution"
            value="unevenly"
            checked={store.simulateFreqs}
            onChange={() => store.setSimulateFreqs(true)}
          />
          <label className="radio-selector__input-label" htmlFor="unevenly">С учетом частотности запросов</label>
        </div>
      </div>
    </div>
  );
});

export default RadioSelector;
